import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { Frame, TopBar, Navigation, Page, Banner } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { runSetup } from './lib/api';
import Home from './pages/Home.jsx';
import FormEdit from './pages/FormEdit.jsx';
import Products from './pages/Products.jsx';

export default function App() {
  const navigate = useNavigate();
  const [setupStatus, setSetupStatus] = useState('idle');
  const [setupError, setSetupError]   = useState(null);

  useEffect(() => {
    /* Auto-setup on first load. Idempotent — checks if metaobject definitions
       exist; creates them if missing. */
    if (sessionStorage.getItem('setup-done')) return;
    setSetupStatus('running');
    runSetup()
      .then((r) => {
        if (r.error) { setSetupStatus('error'); setSetupError(r.error); }
        else        { setSetupStatus('done');  sessionStorage.setItem('setup-done', '1'); }
      })
      .catch((e) => { setSetupStatus('error'); setSetupError(e.message || String(e)); });
  }, []);

  const navMarkup = (
    <Navigation location="/">
      <Navigation.Section
        items={[
          { label: 'Form Şablonları', onClick: () => navigate('/'),         selected: location.pathname === '/' },
          { label: 'Ürünlere Ata',    onClick: () => navigate('/products'), selected: location.pathname === '/products' },
        ]}
      />
    </Navigation>
  );

  const topBar = <TopBar />;

  return (
    <Frame topBar={topBar} navigation={navMarkup}>
      {setupStatus === 'running' && (
        <Banner tone="info" title="İlk kurulum çalışıyor…">
          Metaobject ve metafield tanımları oluşturuluyor. Bir kez çalışır, birkaç saniye sürer.
        </Banner>
      )}
      {setupStatus === 'error' && (
        <Banner tone="critical" title="Kurulum hatası">
          {setupError}
        </Banner>
      )}
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/forms/new" element={<FormEdit />} />
        <Route path="/forms/:id" element={<FormEdit />} />
        <Route path="/products"  element={<Products />} />
      </Routes>
    </Frame>
  );
}
